import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Form from '@/views/Form'
import Login from '@/views/Login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'mtforms',
    component: Home
  },
  {
    path: '/form/:blueprint/:record',
    name: 'Formulario',
    component: Form
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
